import { Component } from "react";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import withRouter from "../../components/withRouter/withRouter";
import InputField from "../../components/inputField/inputField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import ToggleSwitch from "../../components/toggleSwitch";
import {
  getDedicatedTeams,
  updateDedicatedTeams,
  uploadImageApi,
} from "../../api";
import toast from "react-hot-toast";

class AddUpdateDedicatedTeamsHero extends Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    title: "",
    btnText: "",
    btnUrl: "",
    buttonShow: false,
    subHeading: "",
    loading: true,
    _id: "",
    heroData: [],
  };

  componentDidMount = () => {
    this.getData();
  };

  getData = () => {
    getDedicatedTeams()
      .then((res) => {
        const d = res.data[0]?.hero;

        if (this.props.router.params?.id) {
          const val = d.filter((v) => v._id === this.props.router.params.id)[0];

          console.log("this is the new data ::: ", val);

          this.setState({
            imageUrl: val?.image,
            imageCaption: val?.imageCaption,
            imageAlt: val?.imageAlt,
            title: val?.title,
            subHeading: val?.subHeading,
            buttonShow: val?.buttonShow,
            btnText: val?.buttonText,
            btnUrl: val?.buttonUrl,
            loading: false,
          });
        }

        this.setState({
          _id: res.data[0]?._id,
          heroData: res.data[0]?.hero,
          loading: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong.");
        this.props.router.navigate("/dedicated-teams");
        this.setState({ loading: false });
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
    });
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "technology"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }
    if (!this.state.subHeading) {
      toast.error("Sub Heading is required.");
      return false;
    }

    if (this.state.buttonShow && !this.state.btnText) {
      toast.error("Button text is required.");
      return false;
    }
    if (this.state.buttonShow && !this.state.btnUrl) {
      toast.error("Button Url is required.");
      return false;
    }
    return true;
  };

  handleSubmit = () => {
    if (this.validate()) {
      console.log("inside handle submit");
      this.setState({ loading: true });

      this.uploadImage()
        .then((r) => {
          console.log("uploaded image", r);
          const data = {
            image: r,
            imageCaption: this.state.imageCaption,
            imageAlt: this.state.imageAlt,
            title: this.state.title,
            subHeading: this.state.subHeading,
            buttonText: this.state.btnText,
            buttonUrl: this.state.btnUrl,
            buttonShow: this.state.buttonShow,
          };

          console.log(data);

          if (this.props.router.params?.id) {
            const hero = this.state.heroData.map((val) => {
              if (val._id === this.props.router.params?.id) {
                return {
                  ...data,
                  _id: this.props.router.params?.id,
                };
              } else return val;
            });

            updateDedicatedTeams({ hero }, this.state._id)
              .then((res) => {
                toast.success("Updated successfully.");
                this.setState({ loading: false });
                this.props.router.navigate("/dedicated-teams");
              })
              .catch((err) => {
                console.log("Error: ", err);
                toast.error("Something went wrong");
                this.setState({ loading: false });
              });
          } else {
            const hero = [
              ...this.state.heroData,
              {
                ...data,
              },
            ];
            updateDedicatedTeams({ hero }, this.state._id)
              .then((res) => {
                toast.success("Updated successfully.");
                this.setState({ loading: false });
                this.props.router.navigate("/dedicated-teams");
              })
              .catch((err) => {
                console.log("Error: ", err);
                toast.error("Something went wrong");
                this.setState({ loading: false });
              });
          }
        })
        .catch((er) => {
          toast.error("Error While uploading image.");
          this.setState({ loading: false });
        });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title="Add Hero Carousel"
            showBtn1={true}
            btn1Text="Save"
            btn1Name="btn1"
            btn1type="filled"
            showBtn2={true}
            btn2Text="Cancel"
            btn2Name="btn2"
            btn2type="outlined_del"
            onClickHandler={(e) => {
              console.log(e);
              if (e.target.name === "btn1") {
                this.handleSubmit();
              } else this.props.router.navigate("/dedicated-teams");
            }}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                      marginBottom: "10px",
                    }}
                  >
                    Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "45%",
                        aspectRatio: "16/9",
                        backgroundImage: `url('${
                          this.props.router.params.id
                            ? this.state.isImageChanged
                              ? this.state.imageUrl
                              : this.state.imageUrl
                            : this.state.imageUrl
                        }')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        marginBottom: "40px",
                        marginTop: "10px",
                        borderRadius: "15px",
                        position: "relative",
                      }}
                    ></div>
                  )}
                </div>
                {this.state.imageUrl && (
                  <div className="grid_2">
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Caption"}
                      value={this.state.imageCaption}
                      onChange={(e) => {
                        this.setState({ imageCaption: e.target.value });
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Alt"}
                      value={this.state.imageAlt}
                      onChange={(e) =>
                        this.setState({ imageAlt: e.target.value })
                      }
                    />
                  </div>
                )}
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Title"}
                    value={this.state.title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    showCharLength={true}
                    limitChar={40}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Sub Heading"}
                    value={this.state.subHeading}
                    onChange={(e) =>
                      this.setState({ subHeading: e.target.value })
                    }
                  />
                  <div
                    style={{
                      height: "50px",
                      width: "100%",
                      border: "1px solid lightgrey",
                      background: "white",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      paddingInline: "15px",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <p>Show Button</p>
                    <ToggleSwitch
                      value={this.state.buttonShow}
                      onClick={() => {
                        this.setState({ buttonShow: !this.state.buttonShow });
                      }}
                    />
                  </div>
                  {this.state.buttonShow && (
                    <>
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Button Text"}
                        value={this.state.btnText}
                        onChange={(e) =>
                          this.setState({ btnText: e.target.value })
                        }
                      />
                      <InputField
                        type="text"
                        isLabel={true}
                        lable={"Button Url"}
                        value={this.state.btnUrl}
                        onChange={(e) =>
                          this.setState({ btnUrl: e.target.value })
                        }
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateDedicatedTeamsHero);
